<template>

    <img :class="classes" :ref="refs" :src="getImageUrl(path_image)"
        @error="setDefaultImage($event, '@/assets/img/icons/member.png', getImageUrl(path_image))"
        alt="Selected Image" />
</template>

<script setup lang="ts">
import { toRefs, defineProps } from 'vue';
import { clubUUID } from '@/shared/state';
import { setDefaultImage, getImageUrl } from '@/utils/global'

const props = defineProps({
    gender: {
        type: String,
        default: '',
    },
    path_image: {
        type: String,
        default: '',
    },
    classes: {
        type: String,
        default: '',
    },
    refs: {
        type: String,
        default: '',
    }
});

const { classes, path_image } = toRefs(props);

</script>

<style>
.bg-none {
    background: none !important;
}

.img-fiche-member {
    width: 150px;
    height: 150px;
    object-fit: cover; 
}

.img-table {
    width: 50px;
    height: 50px;
    object-fit: cover;
}

.qrcode-member {
    width: 150px;
    height: 150px;
    object-fit: cover;
}
</style>